import {Card} from "@material-tailwind/react";
import useInputValue from "../../hooks/useInputValue";
import {useTranslation} from "react-i18next";
import CustomInputSearch from "../../components/general/CustomInputSearch";
import {useEffect, useState} from "react";
import {CustomRadioButton} from "../../components/general/CustomRadioButton";
import ModalSearch from "./modal-search";
import {showToast} from "../../components/general/CustomToast";
import LogoLarge from "../../components/general/LogoLarge";
import {useFindPersonList} from "../../services/apis/apiPerson";
import {useSearchPersonStorage} from "../../services/storage/PersonSearchStorage";

const listOptions = [
    {label: 'identification-card', type: 'identification'},
    {label: 'ruc', type: 'ruc'},
    {label: 'phone', type: 'telephone'},
    {label: 'names', type: 'names'},
    {label: 'plate', type: 'plate'},
]

const Search = () => {
    const {
        mutate: getPersonList,
        isPending: loadingListPerson,
        data: successListPerson
    } = useFindPersonList()

    const { t } = useTranslation("global") as { t: (key: string) => string };
    const [open, setOpen] = useState(false)
    const input = useInputValue('')
    const [selectedOption, setSelectedOption] = useState<string>('identification')
    const setListResponse = useSearchPersonStorage(data => data.setList)

    const handleOptionChange = (optionLabel: string) => {
        input.setValue('')
        setSelectedOption(optionLabel);
    };

    useEffect(() => {
        if (successListPerson) {
            setListResponse(successListPerson)
        }
    }, [successListPerson]);

    return(
        <div className={'max-w-[750px] mx-auto min-h-[80vh] flex'}>
            {open &&
                <ModalSearch
                    loading={loadingListPerson}
                    value={input.value}
                    type={selectedOption}
                    {...{open, setOpen}}
                />
            }
            <Card placeholder={'card'} className={'custom-card my-auto w-full px-4 py-4 grid grid-cols-1 sm:grid-cols-2'}>
                <div>
                    {listOptions.map(option => {
                        return <CustomRadioButton
                            disabled={loadingListPerson}
                            key={option.type}
                            label={t(option.label)}
                            value={option.type === selectedOption}
                            onChange={() => handleOptionChange(option.type)}
                        />
                    })}
                </div>
                <div className={'flex flex-col'}>
                    <div className={'flex flex-col items-end'}>
                        <LogoLarge textClassName={'text-header text-[20px] mt-[-8px]'}/>
                        <h5>{t('search-info')}</h5>
                    </div>
                    <CustomInputSearch
                        disabled={loadingListPerson}
                        type={getType(selectedOption)}
                        maxLength={getMaxLength(selectedOption)}
                        className={'mt-auto w-full'}
                        label={t('search')}
                        placeholder={getExample(selectedOption, t)}
                        onClick={() => {
                            const min = getMinLength(selectedOption)
                            const namesArray = input.value.split(' ');
                            if (selectedOption === 'names' && min && (min > input.value.length || (namesArray.length < 2 || (namesArray.length > 1 && namesArray[1] === '')))) {
                                showToast(t('alert-search-name'), 'info')
                                return
                            }
                            if ((min && min > input.value.length ) || input.value === '') {
                                showToast(t('alert-search'), 'info')
                                return;
                            } else {
                                getPersonList({type: selectedOption, identifier: input.value, page: 0})
                                setOpen(true)
                            }
                        }} {...input}/>
                    <h6>{`${t('search-window')}: ${t(selectedOption)}`}</h6>
                    <h6 className={'text-gray-500 text-[10px]'}>{`${getExample(selectedOption, t)}`}</h6>
                </div>
            </Card>
        </div>
    )
}

function getType(type: string) {
    switch (type) {
        case 'identification-card':
        case 'identification':
            return 'identification';
        case 'ruc':
            return 'integer';
        case 'phone':
        case 'telephone':
            return 'telephone';
        case 'names':
            return 'letters';
        case 'plate':
            return 'letters-number';
    }
}

function getMaxLength(type: string) {
    switch (type) {
        case 'identification-card':
        case 'identification':
            return 10;
        case 'ruc':
            return 13;
        case 'phone':
        case 'telephone':
            return 13;
        case 'names':
            return 50;
        case 'plate':
            return 7;
    }
}

function getMinLength(type: string) {
    switch (type) {
        case 'identification-card':
        case 'identification':
            return 10;
        case 'ruc':
            return 13;
        case 'phone':
        case 'telephone':
            return 9;
        case 'names':
            return 3;
        case 'plate':
            return 6;
    }
}

function getExample(type: string, t: any) {
    switch (type) {
        case 'identification-card':
        case 'identification':
            return '';
        case 'ruc':
            return '';
        case 'phone':
        case 'telephone':
            return '';
        case 'names':
            return `${t('surname')}  ${t('second-surname')}  ${t('first-name')}  ${t('second-date')}`;
        case 'plate':
            return '';
    }
}

export default Search
